<div class="servicio">
  <div class="intro">
    <div class="user-data">
      <div class="welcome">
        <div class="info">
          <div class="titulo-servicios">
            <h1>Crea tu nueva contraseña</h1>
          </div>
          <p>Recuerda que deberá tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.</p>
        </div>
        
        <div class="text-field">
          <div class="content password-field">
            <input 
              [type]="showCurrentPassword ? 'text' : 'password'" 
              placeholder="Contraseña anterior *" 
              [(ngModel)]="currentPassword"
              maxlength="128"
              autocomplete="current-password">
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility('current')">
              <mat-icon>{{ showCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
        </div>
        
        <div class="text-field">
          <div class="content password-field">
            <input 
              [type]="showNewPassword ? 'text' : 'password'" 
              placeholder="Nueva contraseña *" 
              [(ngModel)]="newPassword"
              maxlength="128"
              autocomplete="new-password">
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility('new')">
              <mat-icon>{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          

        </div>
        
        <div class="text-field">
          <div class="content password-field">
            <input 
              [type]="showConfirmPassword ? 'text' : 'password'" 
              placeholder="Confirma tu nueva contraseña *" 
              [(ngModel)]="confirmPassword"
              maxlength="128"
              autocomplete="new-password">
            <button type="button" class="toggle-password" (click)="togglePasswordVisibility('confirm')">
              <mat-icon>{{ showConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          
          <!-- Indicador de coincidencia -->
          <div class="password-match" *ngIf="confirmPassword">
            <span [class]="newPassword === confirmPassword ? 'match-success' : 'match-error'">
              {{newPassword === confirmPassword ? '✓ Las contraseñas coinciden' : '✗ Las contraseñas no coinciden'}}
            </span>
          </div>
        </div>

        <!-- Requisitos de contraseña -->
        <div class="password-requirements" *ngIf="newPassword">
          <div class="requirement-item" [class.met]="newPassword.length >= 8">
            <mat-icon class="requirement-icon">check</mat-icon>
            <span>Mínimo 8 caracteres</span>
          </div>
          <div class="requirement-item" [class.met]="hasUpperCase(newPassword)">
            <mat-icon class="requirement-icon">check</mat-icon>
            <span>Una letra mayúscula</span>
          </div>
          <div class="requirement-item" [class.met]="hasLowerCase(newPassword)">
            <mat-icon class="requirement-icon">check</mat-icon>
            <span>Una letra minúscula</span>
          </div>
          <div class="requirement-item" [class.met]="hasNumber(newPassword)">
            <mat-icon class="requirement-icon">check</mat-icon>
            <span>Un número</span>
          </div>
          <div class="requirement-item" [class.met]="hasSpecialChar(newPassword)">
            <mat-icon class="requirement-icon">check</mat-icon>
            <span>Un carácter especial</span>
          </div>
        </div>


      </div>
    </div>
    
    <div class="button-row">
      <button type="button" class="btn-primary" 
              (click)="changePassword()" 
              [disabled]="!isFormValid()">
        <span>Cambiar contraseña</span>
      </button>
    </div>
  </div>
</div>